module.exports = __webpack_public_path__ + "static/media/bg-login.cc713f46.svg";